<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Obrazci</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
    <Grid  
                       
                      
                        :data-items="gridData"
                        :columns="columns"
                          @datastatechange="dataStateChange"
                       
                       :edit-field="'inEdit'"
                        @itemchange="itemChange"

                        
                        
                      
                        

                         
                        
                                               >
                  <template v-slot:ukaznigumbi="{props}">
                  <ukaznigumbiknt :data-item="props.dataItem"   :editDisabled="editDisabled"
                    @edit="edit"
                    @save="saveItem" 
                    @remove="removeItem"
                    @cancel="cancel"/>

                    </template>
                 <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                           <!--
                           <button
                                title="Omogoči urejanje"
                                class="k-button k-primary"
                               
                            >
                                Omogoči urejanje
                            </button>
                            <button
                             :disabled="editDisabled"
                                title="Shrani"
                                class="k-button k-primary"
                                @click="shraniKulture"
                            >
                                Shrani
                            </button>
                      -->    
                        <button title="Dodaj"
                                class="k-button k-primary"
                                @click="insert">
                                Dodaj obrazec
                        </button>
                      
                        
                            
                             
                              
                            
                            <!--
                        <button
                                title="Export to Excel"
                                class="k-button k-primary"
                                @click="exportExcel"
                            >
                                Izvozi v Excel
                            </button>
                        <button
                                title="Obrazec za površine"
                                class="k-button k-primary"
                                @click="kontrolniList"
                            >
                                Obrazec za površine
                            </button>
                          -->
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                    <div v-if="dataLoading" class="k-loading-mask loadingIconSpace">
                      <span class='k-loading-text'></span>
                      <div class='k-loading-image'></div>
                      <div class='k-loading-color'></div>
                      
                    </div>
                    <div v-else>
                      Ni podatkov!
                    </div>
                    </GridNoRecords>
                    </Grid>

                    </div>
    </div>

</template>

<script>
import { mapState, mapActions,mapMutations } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
import '@progress/kendo-ui' // This will iminnport the entire Kendo UI library
// As an alternative, you could import only the scripts that are used by a specific widget:
// import '@progress/kendo-ui/js/kendo.treelist' // Imports only the TreeList script and its dependencies

import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
//import { TreeList, TreeListInstaller } from '@progress/kendo-treelist-vue-wrapper'
import sifrantKulture from './support/kulture-data';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import StatusDownCell from './support/SifrantStatusovDropDown';
import StatusCommandCell from './support/SifrantStatusovCommandCell';
import SifrantKulturDownCell from './support/SifrantKulturDropDown';
import PridelovalecKratko from './support/PridelovalecKratko';
//import { sifrantService } from '../services';


//import likelySubtags from 'cldr-core/supplemental/likelySubtags.json';
//import numbers from 'cldr-numbers-full/main/es/numbers.json';
//load(
    //likelySubtags,
    //numbers);

import { process } from '@progress/kendo-data-query';
import moment from 'moment'



const CommandCell = Vue.component("template-component", {
    props: {
        field: String,
        dataItem: Object,
        format: String,
        className: String,
        columnIndex: Number,
        columnsCount: Number,
        rowType: String,
        level: Number,
        expanded: Boolean,
        editor: String,
        sezona: Number
    },
    computed: {
        //poglej če je group header
        //poglej če obstaja this.dataItem.field in potem this.data.items[0][field]
    /*
     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziGerke"  title="Gerki">
                         <font-awesome-icon icon="layer-group"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediKulture" title="Kulture">
                         <font-awesome-icon icon="seedling"/>
                    </button>
                    <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediZivali" title="Živali">
                         <font-awesome-icon icon="horse-head"/>
                    </button>
                     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="urediProizvode" title="Proizvodi">
                         <font-awesome-icon icon="cheese"/>
                    </button>
    */     
    },
    template: ` <td>
     <div class="km-widget km-buttongroup k-widget k-button-group k-button-narrow">

                    <button
                        class="k-primary k-button k-grid-edit-command" :disabled="editDisabled"
                        @click="urediObrazec" title="Uredi">
                         <font-awesome-icon icon="edit"/>
                         
                    </button>
                     <button
                        class="k-primary k-button k-grid-edit-command"
                        @click="prikaziObrazec" title="Prikaži">
                         <font-awesome-icon icon="file-alt"/>
                         
                    </button>
                    </div>
                </td>
                `,
    computed:{
        editDisabled(){
          return this.dataItem._id?false:true;
        },
    },
    methods: {
        urediObrazec: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'izdelajobrazec', params: { obrazecid:this.dataItem._id } })
            
        },
        prikaziObrazec: function() {
           //this.select({pridelovalec:this.dataItem});
           
           this.$router.push({ name: 'prikaziobrazec', params: { obrazecid:this.dataItem._id } })
            
        },
      
    }
});


export default {
  components:{
        'ukaznigumbiknt': StatusCommandCell,
     
      'Grid': Grid,
      'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
       'pridelovalec':PridelovalecKratko
  },
  props:['sezona','pridelovalecid'],
    data () {
        return {
            //defaultItemSezona: { sezona: 'Izberi sezono...'},
            sifrantTree:{},
            dataLoading:false,
            
            
           
            updatedData: [],
            editID: null,
          
         
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],
            columns: [
            //    { field: "ime", title:"Ime",editable:false,width: "150px"},
                //{ field: "kmgmid", title:"KMG-MID",editable:false,width: "150px"},
                //{ field: "naslov", title:"Naslov",editable:false,width: "250px"},

                //{ field: "postnastevilka", title:"Pošta",editable:false,width: "130px"},
                //iz idja naložit šifro
                { field: "stevilkaobrazca", title:"Številka",width: "200px"},
                { field: "revizija", title:"Revizija",width: "100px"},
                { field: "naziv", title:"Naziv",width: "100px"},
                { field: "datumizdaje", title:"Datum izdaje", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "datumveljavnosti", title:"Datum veljavnosti", editor: 'date',width: "170px",format: '{0:d}',validation: { required: true}},
                { field: "veljaven", title:"Veljaven", editor: 'boolean',width: "170px", cell:this.veljavenIcon,validation: { required: true}},
                //{ cell: 'ukaznigumbi', width: '210px', hidden:this.editDisabled },
                
              
              
                //  { field: "status", title:"Status", cell:StatusCell},
                //gerk view link http://rkg.gov.si/GERK/WebViewer/#query=GERK_SDO:GERK_PID:4605424
                //kmg view
                //http://rkg.gov.si/GERK/WebViewer/#KMG=100735069
                //{ field: 'stanje', title: '', cell: this.cellFunction },
               // { field: "statuspridelovalca", title:"Status",editable:false,width: "200px"},
                //{ field: "kontrolnaorganizacija", title:"V kontroli pri",editable:false,width: "200px"},
                //{ field: "jeaktivna", title:"Aktivna",editable:false,filter:'boolean',width: "100px"},
                
                
                //{ field: "pisanje", title:"Dovoli pisanje",editor: 'boolean',filter:'boolean',width: "150px" },
                { title: "Uredi obrazec", cell: CommandCell,filterable:false,columnMenu: null,width:"130px",sortable:false}
            ],
          

           

        }
    },
      computed: {

        //...mapState('sifrant', ['sifrant']),
        editDisabled(){
          return true;
        },
        ...mapState({gridData(state) {
         // console.log(state.kultura);
         //make editable?
          return state.obrazec.certifikat;
        }}),

        

        hasItemsInEdit() {
            return this.gridData.filter(p => p.inEdit).length > 0;
        },
      
           },
    created () {

      //potegni šifrant iz sifrantstore
     /* var groupedAreas = [];
dataItems.map(function(d) {
  if(groupedAreas.filter(function(item, i) {
   return item.areaName === d.AreaName; 
  }).length === 0) {
    groupedAreas.push({ areaName: d.AreaName, subsidiaries:  dataItems.filter(function(r) { return r.AreaName === d.AreaName; }) });
  }
});*/

this.naloziPodatke();

      
    },
  


    methods: {
        ...mapActions('obrazec', ['load','save']),
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapMutations('obrazec',['update',"add","remove","makeEditable",'replace']),
        ...mapActions('pridelava', ['loadIdPoSezoni','loadOne']),
        //...mapActions('sifrant', ['load']),
         veljavenIcon: function (h, defaultElement , props, listeners ) {
            if(props.dataItem.inEdit)
                return defaultElement;

            let veljaven=h('font-awesome-icon',{props:{icon:"times"}});
            if(props.dataItem.veljaven)
                veljaven=h('font-awesome-icon',{props:{icon:"check"}},{class:{"action_success":true}});
            let veljavenWrapper=h('span', {class:{
                'k-badge':true,'k-badge-solid':true,'k-badge-md':true,'k-badge-pill':true,
                "action_error":!props.dataItem.veljaven,"action_success":props.dataItem.veljaven}}, [veljaven]);
            return h('td', {attrs:{colspan:1}}, [veljavenWrapper]);
        },
       
        naloziPodatke: function(){
          this.dataLoading=true;
        this.replace([]);
        this.load().then(
          data=>{this.dataLoading=false;},
          error=>{console.log("tukaj sem!!!");this.dataLoading=false;}
          );
        
      
        },
        
        itemChange: function (e) {
            //const updatedData  = this.gridData.slice();
            if(!e.dataItem.oldValues)
              e.dataItem.oldValues={}
            if(!e.dataItem.oldValues[e.field])
              e.dataItem.oldValues[e.field] =e.dataItem[e.field];
          
          e.dataItem[e.field] = e.value;
          if(e.field=="veljaven")
            e.dataItem[e.field]=e.value?1:0;
          
         //   const item = this.update(e.dataItem);
            //item[e.field] = e.value;
            //this.repalce(updatedData);
        },
         insert() {
            this.$router.push({ name: 'izdelajobrazec' })
          //  this.repalce(newproducts);
        },
        edit: function (e) {
          //console.log(e);
            console.log(e.dataItem)
            e.dataItem.inEdit = true;
            e.dataItem.veljaven = 1;
            
            this.update(e.dataItem);
            console.log(this.kultura);
        },
        cancel(e) {
            if (e.dataItem.id>0) {
            var dataItem=e.dataItem;
            for (const value in dataItem.oldValues){
                dataItem[value]=dataItem.oldValues[value];
            }
              this.update(dataItem);
            
            } else {
                this.remove(e.dataItem);
            }
        },
        saveItem: function(e) {
          console.log(e.dataItem);
          for (const value in e.dataItem.newValues){
            e.dataItem[value]=e.dataItem.newValues[value];
          }
           e.dataItem.inEdit = undefined;
             e.dataItem.veljaven = 1;
          //  const data = this.gridData.slice();
            this.update(e.dataItem);
            //e.dataItem.id = this.update(kulture, e.dataItem).id;
        },
        removeItem(e) {
            e.dataItem.inEdit =!e.dataItem.inEdit;
            //this.update(this.gridData, e.dataItem, true);
            e.dataItem.veljaven=e.dataItem.veljaven?0:1;
            this.update(e.dataItem);

            //this.remove(e.dataItem);
            //console.log(this.gridData);
            //this.replace(this.gridData.slice());
        },
     nogaVsotaPovrsin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota površin: ' + this.kulture.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)+ ' ha']);
        },
     nogaVsotaKolicin: function (h, emptyElement , props, listeners ) {
          if(this.kulture)
            return h('span', {}, ['Vsota količin: ' + this.gerk.reduce((acc, current) => acc+=current.povrsina, 0).toFixed(2)]);
        },
    

       


        
dataStateChange (event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);
                 //  console.log(this.skip);
            this.dataResult = process(this.gerk, {});
           // console.log(this.dataResult);

        },
      
        shraniKulture () {
          //  this.$router.go(-1);
          //console.log(this.dataResult);
        

              this.save();
      //         this.load({sezona:this.dataSezona.sezona,pridelovalecid:this.pridelovalecid});

                     
        },
       
        /*
        changeStatus: function (e) {
            console.log("Gerk change!!!");
            console.log(e.dataItem);
          //  Vue.set(e.dataItem, 'inEdit', true);
        },
*/
        //do doli
        
    }
};
</script>

